<ng-template #itemTemplate let-item="item" let-onCollapseExpand="onCollapseExpand"
             let-onCheckedChange="onCheckedChange">
  <div class="form-inline row-item">
    <i *ngIf="item.children" (click)="onCollapseExpand()" aria-hidden="true" class="fa"
       [class.fa-caret-right]="item.collapsed"
       [class.fa-caret-down]="!item.collapsed"></i>
    <div class="form-check">
      <input type="checkbox" class="form-check-input" [(ngModel)]="item.checked" (ngModelChange)="onChangeItem(item)"
             [disabled]="item.disabled"
             [indeterminate]="item.indeterminate" />
      <label class="form-check-label" (click)="item.checked = !item.checked; onChangeItem(item)">
        {{item.text}}
      </label>
    </div>
  </div>
</ng-template>


<re-alert *ngIf="successAlert" [type]="successAlert.type" (close)="successAlert = null">{{ successAlert.message }}</re-alert>
<re-alert *ngIf="alert" [type]="alert.type" (close)="alert = null">{{ alert.message }}</re-alert>

<h1>
  Create New User
</h1>
<div class="alert alert-info" role="alert" *ngIf="isPhysicianNppaUser">
  <i class="alert-close" data-dismiss="alert" (click)="closeAlert()" aria-hidden="true" aria-label="Close"></i>
  <b>Matrixcare 360:</b> For Physician/NPPA users: eSignatures, EPCS, Discharge Orders using SureScripts and Provider Groups are managed in MatrixCare 360.
</div>
<div class="text-right" style="margin-bottom:15px">
  <a (click)="expandAll()" [routerLink]="[]">Expand All</a> | <a (click)="collapseAll()" [routerLink]="[]">Collapse All</a>
</div>
<ng-template #popContent>
<re-password-requirements [password]="createUserForm.value.password"
                            [username]="createUserForm.value.userName"
                            [firstName]="createUserForm.value.firstName"
                            [lastName]="createUserForm.value.lastName"
                            [domain]="selectedDomain">
  </re-password-requirements>


</ng-template>


<form id="createUserForm" (ngSubmit)="save()" [formGroup]="createUserForm">
  <fieldset [disabled]="waiting">

    <div class="row mb-2">
      <div class="col-4" style="padding-right: 5px;">
        <div class="form-group input-required">
          <label for="configId">Environment</label>
          <select2 [(ngModel)]="user.configId"
                   [disabled]="environments?.length==2"
                   (onSelect)="environmentChanged($event)"
                   [settings]="environmentSettings"
                   formControlName="configId"
                   [options]="environments"></select2>
          <span *ngIf="createUserForm.controls['configId'].hasError('invalid')" class="text-danger mt-1 ml-2 mb-0">Please select Environment.</span>
        </div>
      </div>
      <span class="spinner spinner-sm col-8" style="margin-top: 32px !important;" *ngIf="environmentLoading">
        <span class="lspinner"></span>
      </span>
    </div>

    <re-collapsible-group header="Profile Details" [isCollapsed]="isProfileDetailCollapsed">
      <ng-container>
        <div class="row">


          <div class="form-group col-12 col-sm-6 col-lg-4 i">
            <label for="prefix">Prefix</label>

            <ng-select2 class="user-create" [(ngModel)]="user.prefix" allowClear="true"
                        [options]="{placeholder: 'Not Selected',width:'100%'}" formControlName="prefix"
                        [data]="prefixData"></ng-select2>
          </div>



          <div class="form-group col-12 col-sm-6 col-lg-4 input-required" [ngClass]="{'has-danger':!createUserForm.controls['firstName'].valid && createUserForm.controls['firstName'].touched}">
            <label for="firstName">First Name</label>
            <input id="firstName" class="form-control" type="text" formControlName="firstName" value="" placeholder="First Name" (input)="valueChange()">
            <small *ngIf="createUserForm.controls['firstName'].hasError('required') && createUserForm.controls['firstName'].touched"
                   class="text-danger">Please enter your first name.</small>
          </div>
          <div class="form-group col-12 col-sm-6 col-lg-4">
            <label for="middleName">Middle Name</label>
            <input id="middleName" class="form-control" type="text" formControlName="middleName" value="" placeholder="Middle Name">
          </div>


        </div>
        <div class="row">

          <div class="form-group col-12 col-sm-6 col-lg-4 input-required" [ngClass]="{'has-danger':!createUserForm.controls['lastName'].valid && createUserForm.controls['lastName'].touched}">
            <label for="lastName">Last Name</label>
            <input id="lastName" class="form-control" type="text" formControlName="lastName" value="" placeholder="Last Name" (input)="valueChange()">
            <small *ngIf="createUserForm.controls['lastName'].hasError('required') && createUserForm.controls['lastName'].touched" class="text-danger">Please enter your last name.</small>
          </div>


          <div class="form-group col-12 col-sm-6 col-lg-4"
               [ngClass]="{'has-danger': !createUserForm.controls['title'].valid && createUserForm.controls['title'].touched, 'input-required': createUserForm.get('physicianNppaEnabled')?.value}">
            <label for="title">Title</label>
            <input id="title" [(ngModel)]="user.title" formControlName="title" type="text" class="form-control" maxlength="10">
            <small *ngIf="createUserForm.controls['title'].hasError('required') && createUserForm.controls['title'].touched" class="text-danger">
              Title is required for Physician NP/PA users.
            </small>
          </div>

          <div class="form-group col-12 col-sm-6 col-lg-4"
               [ngClass]="{'has-danger': !createUserForm.controls['email'].valid && createUserForm.controls['email'].touched, 'input-required': createUserForm.get('physicianNppaEnabled')?.value}">
            <label for="email">Email</label>
            <input id="email" class="form-control" type="email" formControlName="email" placeholder="Email ">
            <p *ngIf="createUserForm.controls['email'].hasError('email') && createUserForm.controls['email'].touched" class="text-danger">Please enter a valid email.</p>
            <small *ngIf="createUserForm.controls['email'].hasError('required') && createUserForm.controls['email'].touched" class="text-danger">
              Email is required for Physician NP/PA users.
            </small>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6 col-lg-3">
            <div class="form-group" [class.input-required]="createUserForm.get('physicianNppaEnabled')?.value">
              <label for="primaryPhone">Primary Phone</label>
              <input id="primaryPhone" [(ngModel)]="user.primaryPhone" formControlName="primaryPhone" type="text" class="form-control" maxlength="10">
              <small *ngIf="createUserForm.controls['primaryPhone'].hasError('pattern') && createUserForm.controls['primaryPhone'].touched" class="text-danger">Please enter a valid phone number</small>
              <small *ngIf="createUserForm.controls['primaryPhone'].hasError('required') && createUserForm.controls['primaryPhone'].touched" class="text-danger">
                Primary Phone is required for Physician NP/PA users.
              </small>
            </div>
          </div>

          <div class="col-sm-6 col-lg-1">
            <div class="form-group">
              <label for="ext">Ext</label>
              <input id="ext" formControlName="ext" class="form-control"
                     type="text" maxlength="5"/>
              <small *ngIf="createUserForm.controls['ext'].hasError('pattern') && createUserForm.controls['ext'].touched" class="text-danger">
                Only numeric values are allowed.
              </small>
            </div>
          </div>


          <div class="col-sm-6 col-lg-4">
            <div class="form-group">
              <label for="mobilePhone">Mobile Phone</label>
              <input id="mobilePhone" [(ngModel)]="user.mobilePhone" formControlName="mobilePhone" type="text" class="form-control" maxlength="10">
              <small *ngIf="createUserForm.controls['mobilePhone'].hasError('pattern') && createUserForm.controls['mobilePhone'].touched" class="text-danger">Please enter a valid phone number</small>
            </div>
          </div>
          <div class="col-sm-6 col-lg-4" *ngIf="employeeIdEnabled">
            <div class="form-group">
              <label for="customerEmployeeId">Employee Id</label>
              <input id="customerEmployeeId" maxlength="50" [(ngModel)]="user.customerEmployeeId" formControlName="customerEmployeeId" type="text" class="form-control">
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6 col-lg-4" *ngIf="(isCustomerAdmin || isLocationAdmin) && !isPhysicianNppaUser">
            <div class="form-group">
              <label for="deactivationDate">Deactivation Date</label>
              <div class="has-feedback datepicker-control">
                <input [minDate]="minDate" #dp="bsDatepicker" autocomplete="off" maxlength="10" bsDatepicker
                       [bsConfig]="{animate:true, containerClass:'theme-dark-blue'}"
                       [(ngModel)]="user.deactivationDate" type="text" class="form-control"
                       formControlName="deactivationDate">
                <a class="form-control-feedback" (click)="dp.toggle()" [attr.aria-expanded]="dp.isOpen"></a>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="showPhysicianNppaCheckbox && (isCustomerAdmin || isLocationAdmin)" class="d-flex align-items-center">
          <div class="form-check">
            <input type="checkbox" id="physicianNppaCheckbox"
                   class="form-check-input" formControlName="physicianNppaEnabled"
                   (click)="onPhysicianNppaChange($event.target.checked)"/>
            <label for="physicianNppaCheckbox" class="form-check-label">Physician NP/PA User</label>
          </div>
        </div>

        <form [formGroup]="createUserForm">
          <!-- Other form fields -->
          <app-physician-nppa-user-child *ngIf="isPhysicianNppaUser && (isCustomerAdmin || isLocationAdmin)"
                [parentForm]="createUserForm"
                [canEditProfileAttribute]="true"
                [editProfile]="true"
                [profileLoading]="false"
                [user]="user"
          ></app-physician-nppa-user-child>
        </form>

      </ng-container>
    </re-collapsible-group>

    <re-collapsible-group header="Credentials" [isCollapsed]="isCredentialsCollapsed">
      <ng-container>


        <div class="row">
          <div class="form-group col-3 col-lg-3 col-xl-3 input-required" [ngClass]="{'has-danger':!createUserForm.controls['userName'].valid && createUserForm.controls['userName'].touched}">
            <label for="userName">Username</label>
            <div class="input-group">
              <input id="userName" class="form-control" type="text" formControlName="userName" value="" [readonly]="domainOptions?.length==0" (input)="valueChange()">
            </div>
            <small *ngIf="createUserForm.controls['userName'].hasError('required') && createUserForm.controls['userName'].touched" class="text-danger">Please enter new user’s username.</small>
            <small *ngIf="createUserForm.controls['userName'].hasError('format') && createUserForm.controls['userName'].touched" class="text-danger">Please enter username without the domain, the domain has been pre populated.</small>
          </div>
          <div class="form-group col-3 col-lg-3 col-xl-3 input-required">
            <label for="domain">Domain</label>
            <div class="input-group">
              <div class="input-group-append">
                <select2 *ngIf="domainOptions?.length>1" [(ngModel)]="selectedDomain"
                         class="d-inline-block"
                         [settings]="{ placeholder: 'Not Selected', width:'100%' }"
                         formControlName="usernameDomains"
                         [options]="domainOptions"></select2>
                <span *ngIf="domainOptions?.length==1" class="input-group-text btn-cancel" style="height:35px" id="basic-addon1">&#64;{{selectedDomain}}</span>
              </div>
            </div>
            <small *ngIf="domainOptions?.length==0" class="text-danger">No valid domain was found.</small>
          </div>
        </div>

        <div class="row" *ngIf="customerFederationEnabled">
          <div class="form-group col-12 co-sm-6 input-required">
            <legend class="col-form-label">Federation Status</legend>
            <div class="form-check form-check-inline">

              <input class="form-check-input" id="federatedUser" formControlName="federatedIdentity"
                     type="radio" [value]="true">
              <label class="form-check-label mr-4" for="federatedUser">Yes, User is federated</label>

              <input class="form-check-input ml-5" id="notFederatedUser" formControlName="federatedIdentity"
                     type="radio" [value]="false">
              <label class="form-check-label" for="notFederatedUser">No, User is not federated</label>
            </div>
          </div>
          <div *ngIf="federationLoginIdEnabled && user.federatedIdentity" class="input-required form-group col-12 col-lg-8 col-xl-6"
               [ngClass]="{'has-danger':!createUserForm.controls['federatedLoginID'].valid && createUserForm.controls['federatedLoginID'].touched}">
            <label for="federatedLoginID">Federated Login Id</label>


            <div class="custom-checkbox custom-control-inline ml-5">
              <input type="checkbox" formControlName="sameAsUsername" id="sameAsUsername" class="custom-control-input">
              <label class="custom-control-label" for="sameAsUsername">Same as Username</label>
            </div>

            <div class="input-group">
              <input id="federatedLoginID" [(ngModel)]="user.federatedLoginID" class="form-control" type="text" formControlName="federatedLoginID">


              <div class="input-group-append">
                <span *ngIf="domainOptions?.length==1" class="input-group-text btn-cancel" style="height:40px" id="basic-addon1">&#64;{{selectedFederatedLoginIdDomain}}</span>

                <select2 [disabled]="createUserForm.get('sameAsUsername').value"
                         *ngIf="domainOptions?.length>1" [(ngModel)]="selectedFederatedLoginIdDomain"
                         class="d-inline-block"
                         [settings]="{placeholder: 'Not Selected', width: '400px'}"
                         formControlName="selectedFederatedLoginIdDomain"
                         [options]="domainOptions"></select2>


              </div>

              <small *ngIf="createUserForm.controls['federatedLoginID'].hasError('maxlength') && createUserForm.controls['federatedLoginID'].touched"
                     class="text-danger">Max 100 characters for Federated Login ID.</small>

            </div>


          </div>
        </div>

        <div class="row" *ngIf="mfaEnabled && !user.federatedIdentity">
          <div class="form-group col-3 co-sm-6">
            <legend class="col-form-label">Sign On Policies</legend>
            <div>
              <ngx-bootstrap-multiselect [ngModelOptions]="{standalone: true}" required [texts]="multiSelectSettingsTexts" [settings]="multiSelectSettings" name="signOnPolicies" [options]="signOnOptions" [(ngModel)]="signOnPolicies"></ngx-bootstrap-multiselect>
            </div>
          </div>
        </div>

        <div class="row" *ngIf="!user.federatedIdentity">
          <div class="form-group col-12 co-sm-6 input-required">
            <legend class="col-form-label " style="margin-top: -8px;">Password Set By</legend>
            <div class="mt-2" *ngIf="!isDummyEmail">
              <ng-container *ngFor="let passwordBy of passwordSetByOptions; let i = index;">
                <div class="form-check form-check-inline">
                  <input class="form-check-input" id="passwordSetBy_{{passwordBy.display}}" formControlName="passwordSetBy" ([ngModel])="passwordSetBy"
                         type="radio" [checked]="passwordBy.value === 'Admin'" [value]="passwordBy.value">
                  <label class="form-check-label" for="passwordSetBy_{{passwordBy.display}}">{{passwordBy.display}}</label>
                </div>
              </ng-container>
            </div>
            <div *ngIf="isDummyEmail">
              Admin
            </div>
          </div>
        </div>

        <div class="row" *ngIf="passwordSetBy === 'Admin' && !user.federatedIdentity">
          <div class="form-group col-sm-6 col-lg-4 input-required" [ngClass]="{'has-danger':!validatePassword() && createUserForm.controls['password'].touched}">
            <label for="password">Password</label>
            <input id="password" class="form-control" formControlName="password" value="" placeholder="Password (required)"
                   [ngbPopover]="popContent" popoverTitle="Password Requirements" placement="right" triggers="focus:blur outsideClick"
                   (input)="valueChange()" [ngClass]="showPassword ? '' : 'key'">
            <small *ngIf="!validatePassword() && createUserForm.controls['password'].touched" class="text-danger">Please enter new user’s temporary password with rules.</small>
          </div>
          <div title="Hide/Show Password" class="mr-1" style="cursor: pointer; display: flex; justify-content: center; align-items: center;"
               [ngClass]="(!validatePassword() && createUserForm.controls['password'].touched) ? 'margin-below' : 'margin-above'">
            <span (click)="$event.preventDefault(); showHidePassword();" style="background-color: #f8f9fa !important;">
              <span class="fa neo-primary-3" [ngClass]="showPassword ? 'fa-eye' : 'fa-eye-slash'" style="font-size: larger;"></span>
            </span>
          </div>
          <div title="Copy to clipboard" style="display: flex; justify-content: center; align-items: center;"
               [ngClass]="(!validatePassword() && createUserForm.controls['password'].touched) ? 'margin-below' : 'margin-above'">
            <button class="btn btn-default btn-sm border-0" style="cursor: pointer;" (click)="$event.preventDefault(); copyText();"
                    style="background-color: #f8f9fa !important;">
              <span style="font-size: larger;" class="fa fa-copy neo-primary-3"></span>
            </button>
          </div>
        </div>

        <div class="row" *ngIf="!user.federatedIdentity">
          <div class="form-group col-12">
            <div class="form-check form-check-inline col-12 co-sm-6" *ngIf="passwordSetBy === 'User'">
              <input class="form-check-input" id="sendActivationEmail" formControlName="sendActivationEmail" type="checkbox" value="" ([ngModel])="sendActivationEmail">
              <label class="form-check-label" for="sendActivationEmail">Send user activation email now</label>
            </div>
            <div class="form-check form-check-inline col-12" *ngIf="passwordSetBy === 'Admin'">
              <input class="form-check-input" id="changePasswordFirstLogin" formControlName="changePasswordFirstLogin" type="checkbox"
                     ([ngModel])="changePasswordFirstLogin" value="">
              <label class="form-check-label" for="changePasswordFirstLogin">User must change password on first login</label>
            </div>
          </div>
        </div>

      </ng-container>
    </re-collapsible-group>

    <h2 class="mt-4">User Access</h2>
    <!-- Showing for all users -->
    <re-collapsible-group header="{{adminAccess}}" [isCollapsed]="isAccessCollapsed">
      <ng-container>
        <div class="row">
          <div class="form-group input-required col-6 col-lg-6 col-xl-6">
            <label for="userType">IDM User Admin Access</label>
            <ng-template #statusTooltip>
              <div>
                <ul>
                  <li *ngIf="adminToolRoleDataContains('RU')">No Admin Rights</li>
                  <li *ngIf="adminToolRoleDataContains('LMA')"><span class="font-weight-bold">Location Admin - </span> All admin rights for single MatrixCare 360 location</li>
                  <li *ngIf="adminToolRoleDataContains('CLA')"><span class="font-weight-bold">Limited Admin - </span> Limited Admins can do password resets for any user across all locations</li>
                  <li *ngIf="adminToolRoleDataContains('UMA')"><span class="font-weight-bold">Corporate Admin - </span> All admin rights for all locations </li>
                  <li *ngIf="adminToolRoleDataContains('LLA')"><span class="font-weight-bold">Location Limited Admin - </span> Limited admin rights for single MatrixCare 360 location </li>
                </ul>
              </div>
            </ng-template>
            <span class="ml-2 text-primary fa-solid fa-circle-info" placement="end" [ngbTooltip]="statusTooltip" tooltipClass="mfa-tooltip"></span>
            <select2 [(ngModel)]="user.adminToolRole" [settings]="{placeholder: 'Not Selected',width:'100%'}" formControlName="adminToolRole"
                     (onSelect)="userAccessTypeChanged()"
                     [disabled]="isPhysicianNppaUser"
                     [ngClass]="{'has-danger':!createUserForm.controls['adminToolRole'].valid && createUserForm.controls['adminToolRole'].touched}"
                     [options]="adminToolRoleData"></select2>
            @if (user.adminToolRole=='UMA' && !createUserForm.controls['email'].value){
            <small class="text-danger">Email address has not been entered and is recommended for admin users</small>
            }
          </div>
          <div class="form-group input-required col-4 col-lg-4 col-xl-4 ml-2" [ngStyle]="{'margin-top': '24px' }" *ngIf="customerFederationEnabled && scimEnabled && !isLocationAdmin">
            <div class="form-check">
              <input class="form-check-input" [(ngModel)]="user.tokenManagement" formControlName="tokenManagement" id="tokenManagement" type="checkbox" value="" [attr.disabled]="isPhysicianNppaUser ? true : null">
              <label class="form-check-label" for="access token management">Access Token Management</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" [(ngModel)]="user.scimMapping" formControlName="scimMapping" id="scimMapping" type="checkbox" value="" [attr.disabled]="isPhysicianNppaUser ? true : null">
              <label class="form-check-label" for="scim mapping">SCIM Mapping</label>
            </div>
          </div>
        </div>
      </ng-container>
    </re-collapsible-group>

    <re-collapsible-group header="{{snfProductName}} Access" [isCollapsed]="isAccessCollapsed" *ngIf="showSnfAccess">
      <ng-container>

        <div class="row">
          <div class="form-group col-sm-6 col-lg-4">
            <!-- <label for="userType">Clear MatrixCare 360 Access Section</label> -->
            <button [disabled]="loading || user.adminToolRole =='LMA' || user.adminToolRole =='LLA'" class="btn btn-default" type="button" (click)="resetMultiCareSection()">
              Clear
            </button>
          </div>
        </div>

        <div class="row">


          <div class="form-group col-sm-6 col-lg-4" [class.input-required]="accessSelectionsRequired()" >
            <label for="userType">User Type</label>
            <select2 [(ngModel)]="user.userType" [disabled]="accessDisabled" (onSelect)="userTypeChanged($event)" [settings]="{placeholder: 'Not Selected', width: '100%'}" formControlName="userType"
                     [options]="userTypeData"></select2>
          </div>


          <div class="col-sm-6 col-lg-4">
            <div class="form-group" [class.input-required]="accessSelectionsRequired()">
              <label for="corporationName">Corporation Name</label>

              <select2 [(ngModel)]="user.corporationName" [disabled]="accessDisabled" (onSelect)="corporationChanged($event)" [settings]="corporationSettings" formControlName="corporationName"
                       [options]="corporations"></select2>




            </div>
          </div>
          <div class="col-sm-6 col-lg-4" *ngIf="user.userType==careSettingName">

            <div class="form-group" [class.input-required]="accessSelectionsRequired()">
              <label for="careSettingName">Care Setting Name</label>
              <select2 [(ngModel)]="user.careSettingName" [disabled]="accessDisabled" (onSelect)="careSettingChanged($event)" [settings]="careSettingSettings" formControlName="careSettingName"
                       [options]="careSettings"></select2>
            </div>
          </div>

        </div>

        <div class="row">
          <div class="form-group col-sm-6 col-lg-4" [class.input-required]="accessSelectionsRequired()">
            <label for="role">Template</label>
            <select2 [disabled]="accessDisabled" [(ngModel)]="user.role" (onSelect)="roleChanged($event)" [settings]="roleSettings" formControlName="role"
                     [options]="roles"></select2>
            <span class="helpText"> (Select from dropdown or enter custom data)</span>
          </div>

          <div class="form-group col-sm-6 col-lg-4" [class.input-required]="isDisciplineRequired && !isCustomRole" *ngIf="isDisciplineRequired && user.userType==careSettingName">
            <label for="primaryDiscipline">Primary Discipline</label>
            <select2 [disabled]="accessDisabled" [(ngModel)]="user.primaryDiscipline" [settings]="disciplineSettings" formControlName="primaryDiscipline"
                     [options]="disciplines"></select2>
            <small *ngIf="createUserForm.controls['primaryDiscipline'].hasError('disciplineRequired') || createUserForm.controls['role'].hasError('disciplineRequired') " class="text-danger">Primary discipline is a required field</small>
            <span class="helpText"><br />(Select from dropdown or enter custom data)</span>
          </div>

        </div>
        <div class="row" *ngIf="corporateLimited">
          <div class="form-group col-sm-6 col-lg-4">
            <legend class="col-form-label">Corporate Access</legend>
            <p style="text-align:right;" class="mb-2"> Selected facilities: {{selectedFacilities?.length}}</p>
            <ngx-treeview [itemTemplate]="itemTemplate"
                          [config]="config"
                          [items]="regionsTree | ngxTreeViewLocal:'name':'checked'"
                          (selectedChange)="onSelectedChange($event); selectedFacilities = $event;">
            </ngx-treeview>
          </div>
        </div>

        <div *ngIf="isFacilityRoleAssignmentFormLoaded && isPhysicianNppaUser && user.role">
          <form [formGroup]="facilityRoleAssignmentForm">
            <label for="facilitySearch"><b>Facility & Role Assignment</b></label>

            <p style="text-align:right;width: 50%" > Selected facilities: {{getCheckedCount()}}</p>
            <input
              id="facilitySearch"
              type="text"
              class="form-control mb-3"
              placeholder="Search by facility name"
              [formControl]="searchControl"
              style="width: 50%;"
              (input)="filterFacilities($event.target.value)"/>

            <div *ngIf="showSelectAll" class="d-flex align-items-start my-3 facility-bulk-actions" [class.facility-list-scrolled]="facilityListScrolled" style="width: 50%;">
              <div class="d-flex align-items-center mt-2">
                <input type="checkbox" id="selectAllFacilities"
                       [checked]="selectAllChecked"
                       (change)="onSelectAllChange($any($event.target).checked)" />
                <label for="selectAllFacilities" class="ml-2 mb-0 font-weight-bold">Select All</label>
              </div>
              <div class="facility-default-role">
                <label class="mb-0 font-weight-bold">Default Role</label>
                <div class="ml-2" style="min-width: 180px;">
                  <select2 [(ngModel)]="defaultRole" [ngModelOptions]="{standalone: true}"
                           [options]="facilityRoles"
                           [settings]="{ placeholder: 'Not Selected', width: '100%' }"
                           [disabled]="!selectAllChecked"
                           (ngModelChange)="onDefaultRoleChange($event)">
                  </select2>
                </div>
              </div>
            </div>

            <div formArrayName="facilities">
              <div (scroll)="onFacilityListScroll($event)" style="max-height: 400px; overflow-y: auto; overflow-x: hidden; width: 50%">
                <ng-container *ngFor="let facility of facilities.controls; let i = index">
                <div
                  [formGroupName]="i"
                  class="row align-items-center facility-role-row mb-3"
                  *ngIf="facility.get('visible')?.value"> <!-- Only show rows where `visible` is true -->

                  <div class="col-auto d-flex align-items-center facility-role-name" style="gap: 5px;">
                    <input
                      type="checkbox"
                      formControlName="checked"
                      [attr.disabled]="!facility.get('accessible')?.value ? true : null"
                      (change)="onFacilityRoleCheckedChange(i)" />
                    <span class="form-control-plaintext"
                          [ngClass]="{'text-muted': !facility.get('accessible')?.value}">{{ facility.get('name')?.value }}</span>
                  </div>
                  <!-- Dropdown for 'roles' -->
                  <div class="col-sm-6 col-lg-3 facility-role-dropdown">
                    <select2 formControlName="role"
                             [options]="facilityRoles"
                             [settings]="{ placeholder: 'Not Selected', width: '100%' }"
                             [disabled]="!facilityRoleAssignmentForm.get('facilities').controls[i].get('checked').value"
                             (onSelect)="onFacilityRoleAssignmentChange(i)">
                    </select2>
                    <div *ngIf="(facilityRoleAssignmentForm.get('facilities').controls[i].get('role').hasError('required') || !facilityRoleAssignmentForm.get('facilities').controls[i].get('role').value) && facilityRoleAssignmentForm.get('facilities').controls[i].get('checked').value" class="text-danger">
                      Role is required.
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
            </div>
          </form>

        </div>
      </ng-container>
    </re-collapsible-group>

    <!-- Showing for all roles -->
    <re-collapsible-group header="{{multicareMobile}} Access" [isCollapsed]="isAccessCollapsed" *ngIf="showMulticareSection && showSnfAccess">
      <ng-container>
        <div class="row">
          <div class="form-group col-6 col-lg-6 col-xl-6" *ngIf="multicareMobileEnabled">
            <label for="mcmdRole">MatrixCare Engage Mobile App Role</label>
            <br>
            <select2 [settings]="{placeholder: 'Not Selected',width:'50%'}" formControlName="mcmdRole"
                     (onSelect)="mcmdRoleChanged()"
                     [(ngModel)]="user.mcmdRole"
                     [options]="mcmdRoleData"></select2>
          </div>
        </div>
        <div class="row" *ngIf="multicareEformsEnabled">
          <div class="form-group col-6 col-lg-6 col-xl-6">
            <label for="eFormsRole">MatrixCare Engage eForms Role</label>
            <br>
            <select2 [settings]="{placeholder: 'Not Selected',width:'50%'}" formControlName="eFormsRole"
                     (onSelect)="eFormsRoleChanged()"
                     [(ngModel)]="user.eFormsRole"
                     [options]="eFormsRoleData"></select2>
          </div>
        </div>
        <div class="row" *ngIf="createUserForm.controls['mcmdRole'].hasError('invalid') || createUserForm.controls['eFormsRole'].hasError('invalid')">
          <div class="col-12">
            <p class="text-danger mt-1 ml-2 mb-0">Please select MatrixCare 360 Corporation.</p>
          </div>
        </div>
      </ng-container>
    </re-collapsible-group>

    <re-collapsible-group header="{{slProductName}} Access" [isCollapsed]="isAccessCollapsed" *ngIf="enableSLAutoProvisioning">
      <ng-container>
        <div class="form-check">
          <input class="form-check-input" [(ngModel)]="user.slProvisioned" formControlName="slProvisioned" id="optProvisionSL" type="checkbox" value="" checked>
          <label class="form-check-label font-weight-bold" for="optProvisionSL">Provide User Access</label>
        </div>
      </ng-container>
    </re-collapsible-group>

    <re-collapsible-group header="{{trueSenseProductName}} Access" [isCollapsed]="isAccessCollapsed" *ngIf="showTrueSenseAccess">
      <ng-container>
        <div class="form-check">
          <input class="form-check-input" formControlName="trueSenseProvisioned" id="optProvisionTrueSense" type="checkbox" value="">
          <label class="form-check-label font-weight-bold" for="optProvisionTrueSense">Provide User Access</label>
        </div>
      </ng-container>
    </re-collapsible-group>

    <re-collapsible-group header="{{sigmaCareProductName}} Access" [isCollapsed]="isAccessCollapsed" *ngIf="showSigmaCareAccess">
      <ng-container>
        <div class="form-check">
          <input class="form-check-input" formControlName="sigmaCareProvisioned" id="optProvisionSigmaCare" type="checkbox" value="">
          <label class="form-check-label font-weight-bold" for="optProvisionSigmaCare">Provide User Access</label>
        </div>
      </ng-container>
    </re-collapsible-group>

    <re-collapsible-group header="{{pdProductName}} Access" [isCollapsed]="isAccessCollapsed" *ngIf="showPdOfficeData">
      <ng-container>

        <div class="form-group col-sm-6 col-lg-4" [class.input-required]="accessSelectionsRequired()">
          <label for="">Office</label>
          <select2 [(ngModel)]="user.officeId" [disabled]="accessDisabled" [settings]="{placeholder: 'Not Selected', width: '100%'}" formControlName="officeId"
                   [options]="pdOfficeData"></select2>
        </div>
      </ng-container>
    </re-collapsible-group>

    <re-collapsible-group header="{{lpcProductName}} Access" [isCollapsed]="isAccessCollapsed" *ngIf="showLpcAccess">
      <ng-container>
        <div class="row">

          <div class="form-group col-sm-6 col-lg-4">
            <label for="lpcRoles">Role</label>
            <ngx-bootstrap-multiselect [texts]="multiSelectSettingsTexts" [settings]="multiSelectSettings" formControlName="lpcRoles" ngDefaultControl id="lpcRoles" [options]="lpcRoleOptions" [(ngModel)]="user.lpcRoles"></ngx-bootstrap-multiselect>
          </div>

        </div>
      </ng-container>
    </re-collapsible-group>

    <re-collapsible-group header="{{ppProductName}} Access" [isCollapsed]="isAccessCollapsed" *ngIf="showPPAccess">
      <ng-container>
        <div class="row">

          <div class="form-group col-sm-6 col-lg-4">
            <label for="paymentPortalRole">Role</label>
            <div>
              <select2 [settings]="{placeholder: 'Not Selected',width:'100%'}" formControlName="paymentPortalRole"
                       id="paymentPortalRole"
                       [(ngModel)]="user.paymentPortalRole"
                       [ngClass]="{'has-danger':!createUserForm.controls['paymentPortalRole'].valid && createUserForm.controls['paymentPortalRole'].touched}"
                       [options]="ppRoleData" (onSelect)="paymentPortalRoleChanged()"></select2>
              <p *ngIf="createUserForm.controls['paymentPortalRole']?.hasError('invalid')" class="text-danger mt-1 ml-2 mb-0">Please select MatrixCare 360 Corporation.</p>
            </div>
          </div>
        </div>
      </ng-container>
    </re-collapsible-group>

    <re-collapsible-group header="Retail Tracker Online Access" [isCollapsed]="isAccessCollapsed" *ngIf="showRTOAccess">
      <ng-container>
        <div class="row">

          <div class="form-group col-sm-6 col-lg-4">
            <label for="rtoRole">Role</label>
            <div>
              <select2 [settings]="{placeholder: 'Not Selected',width:'100%'}" formControlName="rtoRole"
                       id="rtoRole"
                       [(ngModel)]="user.rtoRole"
                       [ngClass]="{'has-danger':!createUserForm.controls['rtoRole'].valid && createUserForm.controls['rtoRole'].touched}"
                       [options]="rtoRoleData" (onSelect)="rtoRoleChanged()"></select2>
              <p *ngIf="createUserForm.controls['rtoRole']?.hasError('invalid')" class="text-danger mt-1 ml-2 mb-0">Please select MatrixCare 360 Corporation.</p>
            </div>
          </div>
        </div>
      </ng-container>
    </re-collapsible-group>

    <re-collapsible-group header="{{solutionsForBusinessProductName}} Access" [isCollapsed]="isAccessCollapsed" *ngIf="showSolutionsForBusinessAccess">
      <ng-container>
        <div class="row">
          <div class="form-group col-sm-6 col-lg-4">
            <label for="solutionsForBusinessModules">Modules</label>
            <ngx-bootstrap-multiselect
              [texts]="multiSelectSettingsTexts"
              [settings]="multiSelectSettings"
              formControlName="solutionsForBusinessModules"
              ngDefaultControl
              id="solutionsForBusinessModules"
              [options]="solutionsForBusinessModuleOptions"
              [(ngModel)]="user.solutionsForBusinessModules"
              (ngModelChange)="solutionsForBusinessModulesChanged()">
            </ngx-bootstrap-multiselect>
            <small class="text-muted">Select the modules this user can access. Note: User must have a valid MatrixCare 360 corporation to access {{solutionsForBusinessProductName}} Portal.</small>
            <p *ngIf="createUserForm.controls['solutionsForBusinessModules'].hasError('invalid')" class="text-danger mt-1 ml-2 mb-0">Please select MatrixCare 360 Corporation.</p>
          </div>
        </div>
      </ng-container>
    </re-collapsible-group>

    <div class="row">
      <div class="form-group col-12 submit-form-group">
        <button id="createUserButton" class="btn btn-primary" type="submit" [disabled]="(!createUserForm.valid || !validatePassword() || !facilityRoleAssignmentForm.valid)">Create User</button>
        <button type="button" class="btn btn-cancel" [routerLink]="['/users']">Cancel</button>
      </div>
    </div>
  </fieldset>
</form>
